import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { showErrorToast } from "#app/notifications";
import { AccessTokenSingleton } from "#modules/auth/domain/AccessTokenSingleton";
import { isUserDisabledError } from "#modules/auth/domain/isUserDisabledError";

export type User = ClientInferResponseBody<typeof contract.users.me>;

export const fetchUser = async (): Promise<User | null> => {
  const response = await api.users.me.query();

  if (response.status === 200) {
    return response.body;
  }

  if (response.status === 401 && !isUserDisabledError(response.status, response.body)) {
    AccessTokenSingleton.getInstance().resetToken();
    showErrorToast({
      title: "Session expirée",
      message: "Connectez vous à nouveau",
    });
  }

  return null;
};
